import * as React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { GlobalApplicationState } from 'globalApplicationState';
import Button from "@mui/material/Button";

import { BasicTinyMce } from 'modules/common/components/basicTinyMce';
import { GifPicker } from 'modules/common/components/gifPicker/gifPicker';
import { addGif, getInsertedGifs } from 'utils/textEditorUtils';

export interface IEditCommentProps {
    text: string;
    onEdit: (bodyFormatted: string, bodyPlain: string) => Promise<boolean>;
    onCancel: () => void;
    editButtonText: string;
    cancelText: string;
    disabled?: boolean;
}

export interface IEditCommentState {
    bodyPlaintext: string;
    bodyFormatted: string;
    charsCount: number;
    snapshot: string;
}

export class EditComment extends React.Component<PropsWithRedux, ComponentState> {
    constructor(props: PropsWithRedux) {
        super(props);

        const { bodyPlain, bodyFormatted } = props;

        this.state = {
            bodyPlain: bodyPlain,
            bodyFormatted: bodyFormatted,
            charsCount: bodyPlain ? bodyPlain.length : 0,
            snapshot: bodyFormatted,
            gifsVisible: false,
            imageVisible: false,
            editorRef: React.createRef<any>(),
            gifRef: React.createRef<any>()
        };
    }

    public render() {
        const { commentMaxLength, onCancel, savingComment } = this.props;
        const { bodyPlain, bodyFormatted, charsCount, gifsVisible, editorRef, gifRef } = this.state;

        let onlyWhitespace = true;
        if (editorRef.current != null)
            onlyWhitespace = (bodyPlain.trim() === "" && getInsertedGifs(editorRef.current.getContent()) === null)

        return (
            <div className="edit-comment">
                {gifsVisible ?
                    <div className="gif-picker-popover">
                        <GifPicker
                            onSelect={(gif) => addGif(
                                gif,
                                (plain) => this.setState({ bodyPlain: plain }),
                                (visible) => this.setState({ gifsVisible: visible }),
                                this.state.editorRef,
                                this.state.gifRef
                            )}
                            searchPlaceholder="Search GIFs"
                        />
                    </div>
                    : null}
                <BasicTinyMce
                    isGifsVisible={gifsVisible}
                    onChangeIsGifsVisible={(value: boolean) => this.setState({ ...this.state, gifsVisible: value })}
                    editorRef={editorRef}
                    gifRef={gifRef}
                    id="edit-comment-tiny"
                    value={bodyFormatted}
                    onChange={this.handleTinyText}
                    disabled={savingComment}
                />
                <div>
                    <div>
                        <Button variant="contained" color="primary" disabled={savingComment || charsCount === 0 || charsCount > commentMaxLength || onlyWhitespace || gifsVisible} onClick={this.onEdit}>Save</Button>
                        {onCancel &&
                            <Button variant="text" color="primary" style={{marginLeft: "10px"}} disabled={savingComment} onClick={onCancel}>Discard</Button>
                        }
                    </div>
                    <div className={charsCount > commentMaxLength ? "maximum-word-count over-limit" : "maximum-word-count"}>{charsCount}/{commentMaxLength}</div>
                </div>
            </div>
        );
    }

    private handleTinyText = (event, editor) => {
        var count = (editor.getContent({ format: 'text' }).length + ((getInsertedGifs(editor.getContent()) ||
            editor.getContent().match(/<img id="inserted-image"/g)) || []).length)

        this.setState({ ...this.state, bodyFormatted: editor.getContent(), bodyPlain: editor.getContent({ format: 'text' }), charsCount: count })
    }

    private onEdit = () => {
        var plain = this.state.bodyPlain;
        const insertedGifsCount = getInsertedGifs(this.state.editorRef.current.getContent())?.length || 0;
        if (insertedGifsCount > 0 && this.state.bodyPlain === "") {
            plain = "📷 GIF";
        }
        this.props.onEdit(this.state.bodyFormatted, plain, this.state.snapshot).then((response) => {
            if(this.props.confirmCallback)
                this.props.confirmCallback();

            if (response) {
                this.props.onCancel();
            }
        })
    }

}


interface ComponentProps {
    bodyPlain: string;
    bodyFormatted: string;
    onEdit: (bodyFormatted: string, bodyPlain: string, snapshot: string) => Promise<boolean>;
    onCancel: () => void;
    confirmCallback?: () => void;
}

interface ComponentState {
    bodyPlain: string;
    bodyFormatted: string;
    charsCount: number;
    snapshot: string;
    gifsVisible: boolean;
    imageVisible: boolean;
    editorRef: any;
    gifRef: any;
}

const connector = connect(
    (state: GlobalApplicationState, ownProps: ComponentProps) => ({
        ...ownProps,
        commentMaxLength: state.settings.clientSettings.commentSystem.commentMaxLength,
        savingComment: state.posts.postView.savingComment,
    }),
);
type PropsWithRedux = ConnectedProps<typeof connector>;
export default connector(EditComment);
